export const BASE_URL = process.env.REACT_APP_BACKEND_URL;
export const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };